import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=756b991b&scoped=true"
import script from "./Compare.vue?vue&type=script&lang=ts"
export * from "./Compare.vue?vue&type=script&lang=ts"
import style0 from "./Compare.vue?vue&type=style&index=0&id=756b991b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756b991b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756b991b')) {
      api.createRecord('756b991b', component.options)
    } else {
      api.reload('756b991b', component.options)
    }
    module.hot.accept("./Compare.vue?vue&type=template&id=756b991b&scoped=true", function () {
      api.rerender('756b991b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Compare.vue"
export default component.exports